/* Install a serviceworker and ask for permission to use push notifications */
import {
  addInfoBreadcrumbToSentry,
  addWarningBreadcrumbToSentry
} from './sentryErrorLogging';

export const installServiceWorker = () => {
  /* Register service worker for PWA features */
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/serviceworker.js').then(
        (registration) => {
          addInfoBreadcrumbToSentry(
            'pwa',
            `Serviceworker registration successful with scope: ${registration.scope}`
          );
        },
        (err) => {
          addWarningBreadcrumbToSentry('pwa', 'Serviceworker registration failed', {
            message: err.message
          });
        }
      );
    });
  }
};

export const installPushNotifications = () => {
  if ('serviceWorker' in navigator && 'Notification' in window) {
    /* Service worker notifications */
    try {
      Notification.requestPermission().then((status) => {
        /* Ignore status */
      });
    } catch (error) {
      /* Safari only supports requestPermission with a callback function */
      if (error instanceof TypeError) {
        Notification.requestPermission((status) => {
          /* Ignore status */
        });
      } else {
        throw error;
      }
    }
  }
};

/* Add to homescreen prompt for browsers that support it */
let deferredPrompt;
let askedOnce = false;
export const addToHomeScreenSetup = (installationString) => {
  /* Listen to the beforeinstallprompt event */
  window.addEventListener('beforeinstallprompt', (event) => {
    event.preventDefault();
    if (!askedOnce) {
      deferredPrompt = event;
      showInstallPWA();
    }
  });
  /* Show our A2HS banner and install the necessary click handlers */
  function showInstallPWA() {
    const installElement = document.getElementById('PWA');
    const closeButton = document.getElementById('closePWA');
    installElement.querySelector('a').innerHTML = installationString;
    installElement.style.display = 'block';
    installElement.addEventListener('click', installPWA);
    closeButton.addEventListener('click', (e) => {
      e.stopImmediatePropagation();
      hideInstallPWA();
    });
  }
  /* Hide our A2HS banner */
  function hideInstallPWA() {
    const installElement = document.getElementById('PWA');
    installElement.style.display = 'none';
  }
  /* Show the actual prompt, hiding our own banner after cancel/install */
  function installPWA(event) {
    askedOnce = true;
    deferredPrompt.prompt();
    deferredPrompt.userChoice
      .then((choiceResult) => {
        deferredPrompt = null;
      })
      .finally(() => hideInstallPWA());
  }
};

/* Send a push notification */
export const sendPushNotification = (text) => {
  if ('Notification' in window && Notification.permission === 'granted') {
    const options = {
      body: text,
      icon: '/icon-512.png',
      badge: '/badge-icon-96.png'
    };
    navigator.serviceWorker
      .getRegistration()
      .then((reg) => {
        /* Check support on ServiceWorkerRegistration for showNotification */
        if (reg.showNotification) reg.showNotification('Yesplan App', options);
      })
      .catch((error) => {
        /* ignore */
        addWarningBreadcrumbToSentry('pwa', 'Could not send push notification', {
          message: error.message
        });
      });
  }
};
